<template lang="pug">
section.opensite-sec
  .max-container
    .opetitle-wrap
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-left.png')
      .optitle-box
        .optitle {{ $t('ui.quickSetup') }}
        .optitle-shadow {{ $t('ui.quickSetup') }}
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-right.png')
    .opensite-step-wrapper
      .stepnumber-wrap
        .stepnum.active
          img(src='/assets/img/newwebsite/step-1-icon.png')
        .stepnum
          img(src='/assets/img/newwebsite/step-2-icon-dark.png')
      .step-progress-bar.step2
      .step-caption
        .scinfo.active {{ $t('ui.setUpTheme') }}
        .scinfo {{ $t('ui.checkOut') }}
    .theme-setting-wrapper
      .theme-set-wrap
        .ques-text 1. {{ $t('message.pleaseFillUpSiteDetails') }}
        .theme-input-wrap
          DebounceInput.theme-input(
            size="sm"
            ref="siteName"
            id="siteName"
            required
            type="text"
            :dirty="$v.siteName.$dirty"
            :error="$v.siteName.$error"
            :placeholder="$t('ui.siteName')"
            v-model.trim.lazy="$v.siteName.$model"
            :disabled="loading"
          )
          ValidateResult(style="max-width:600px" :value="$v.siteName" :name="$t('ui.site_name')")
      .theme-set-wrap
        .ques-text 2. {{ $t('message.chooseYourPreferedResponsiveLayoutTheme') }}
        .theme-layout-wrapper
          template(v-for="item in themeList")
            .themebox.pointer(
              :class="{ 'active' : themeSelected != null && item.theme_code == themeSelected, 'default' : loading}"
              :disabled="loading"
              :id="item.theme_code"
              v-if="item.enable"
              @click="selectedDesign(item.theme_code)"
              )
              .thm-img-box
                DisplayLayoutBoxNew(:imageURL="item.theme_code + '/' + colorDefaultList[item.theme_code]")
                .tbhover.gallery
                  a(:href="'/assets/img/themeui/desktop/' + item.theme_code + '/' +  colorDefaultList[item.theme_code] + '.jpg?v1'")
                    button.imghvr-btn.pointer
                      span.magnify-icon
                        i.fa.fa-search
                      | {{ $t('ui.information') }}
                  a(:href="'/assets/img/themeui/mobile/' + item.theme_code + '/' +  colorDefaultList[item.theme_code] + '.jpg?v1'")
              .tmpt-wrap
                .tmpt-name
                button.tmpt-apply.pointer
                  span.pick-icon
                    i.fas.fa-crown
                  span.selected-icon
                    i.fas.fa-check-circle
                  | {{ $t('ui.useThisTemplate') }}

            .themebox.default(
              :id="item.theme_code"
              v-else
              )
              .thm-img-box
                DisplayLayoutBoxNew(:imageURL="item.theme_code + '/' + colorDefaultList[item.theme_code]")
              .theme-overlay.d-block
              .text-coming {{ $t('ui.comingSoon') }}

        specialPagination(
          v-if="themeList.length > 0"
          :totalRows="totalRow"
          :pageSize="pageSize"
          @pagechanged="changedPage"
        )

    .pck-btn-wrap
      button.btn.btn-primary.pcknext-btn(type="button" @click="nextStep" :disabled="loading")
        | {{ $t('ui.next') }}
        span.nextarw
          i.fas.fa-arrow-right
</template>

<script>
import errorTags from "@/errorTags";
import config from "@/config";
import DisplayLayoutBoxNew from '@/components/siteeditor/newwebsite/model/DisplayLayoutBoxNew.vue'
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import specialPagination from '@/library/SpecialPagination.vue'

export default {
  components: {
    DisplayLayoutBoxNew,
    ValidateResult,
    DebounceInput,
    specialPagination
  },
  props: {
    cartId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      siteName: '',
      themeList: [],
      themeName: "",
      themeSelected: null,
      colorDefaultList: config.colorDefaultList,
      currentPage: 1,
      pageSize: 6,
      totalRow: 0,
      cartInfo: null,
      firstTime: true
    }
  },
  validations: {
    siteName: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50)
    }
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted() {},
  methods: {
    changedPage: function(pageNo) {
      if(this.firstTime == true) {
        this.firstTime = false;
        return
      }
      this.currentPage = pageNo;
      this.getThemeList(this.cartInfo);
    },
    backStep: function () {
      this.$emit('previousStep')
    },
    nextStep() {
      if (!this.doneAll())
        return

      if (this.cartId == null)
        this.cartCreate();
      else
        this.cartUpdate();
    },
    getCartInfo(cartId) {
      let url = config.cartInfoUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: cartId,
        step_name: 'ALL'
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.cartInfo = response.data.ds
                this.siteName = this.cartInfo.cart[0].site_name
                this.getThemeList(this.cartInfo);

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    cartCreate() {
      let url = config.cartAddUrl();
      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        site_name: this.siteName,
        currency_code: this.getCurrencyCode,
        package_id: 1,
        logo: null
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.reset()
                var cartId = response.data.dt[0].cart_id;
                this.$emit('cartValue', cartId);
                this.cartUiUpdate(cartId);

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    cartUpdate() {
      let url = config.cartUpdateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: this.cartId,
        site_name: this.siteName,
        currency_code: this.getCurrencyCode,
        package_id: 1,
        logo: null
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.cartUiUpdate(this.cartId);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    cartUiUpdate(cartId) {
      let url = config.cartThemeCodeUpdateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: cartId,
        theme_code: this.themeSelected
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.reset();
                var sendData = {
                  cartId: cartId,
                  currentStep: 'THEME',
                  setUpOpAcc: null
                }
                this.$store.dispatch("user/setSelectedNewWebsite", sendData);
                this.$emit('goStep', 2);

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    showToast(title, message, variant) {
      this.$swal.fire({
        title: this.$t('ui.' + title),
        html: this.$t('message.' + message),
        icon: variant,
        confirmButtonText: this.$t("ui.ok")
      })
    },
    doneAll() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$invalid) {
        document.getElementById("siteName").focus();
        return false;
      }

      if (this.themeSelected == null) {
        this.$helpers.showToast(this.$t("ui.hint"), this.$t("message.pleaseSelectTheme"), "info");
        return false
      }

      return true;

    },
    reset() {
      this.$v.$reset()
      this.siteName = ''
      this.loading = false
    },
    getThemeList(info) {
      let url = config.getThemeListWithSelectedUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        page_number: this.currentPage,
        page_size: this.pageSize,
        provider_type: '',
        theme_code: ""
      }

      if (info != null && info.cart[0].theme_code != null) {
        json.theme_code = info.cart[0].theme_code
      }


      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                var theme = response.data.dt
                this.themeList = [];
                this.themeList = theme;
                this.totalRow = this.themeList.length > 0 ? this.themeList[0].totalrows : 0;
                this.setPopUpThemeInfo();

                if (info != null && info.cart[0].theme_code != null) {
                  this.setTheme(info);
                }

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            // console.log(error)
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setPopUpThemeInfo() {
      $(document).ready(function() {
      $('.gallery').each(function() { // the containers for all your galleries
          $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
              enabled:true
            }
          });
        });
      })
    },
    setTheme(data) {
      // if(this.themeList.filter(item => item.theme_code == data.cart[0].theme_code).length > 0)
      //   this.themeSelected = this.themeList.filter(item => item.theme_code == data.cart[0].theme_code)[0].theme_code;
      this.themeSelected = data.cart[0].theme_code
    },
    selectedDesign(value) {
      this.themeSelected = value;
    }
  }
}
</script>
